import React from "react";
import intl from "react-intl-universal";
import { FiMail, FiSmartphone } from "react-icons/fi";
import { RiWhatsappLine } from "react-icons/ri";
import { TbShieldLock, TbUsb } from "react-icons/tb";
import type { VerificationLoginMethod } from "../../../Constants/webauthnMock";

const METHOD_META: Record<
  VerificationLoginMethod,
  { labelKey: string; Icon: React.ComponentType<{ className?: string; "aria-hidden"?: boolean }> }
> = {
  email: { labelKey: "words.email", Icon: FiMail },
  sms: { labelKey: "words.sms", Icon: FiSmartphone },
  fido: { labelKey: "words.usbKey", Icon: TbUsb },
  whatsapp: { labelKey: "words.whatsapp", Icon: RiWhatsappLine },
  google_authenticator: {
    labelKey: "words.googleAuthenticator",
    Icon: TbShieldLock,
  },
};

export interface TwoFactorMethodPickerProps {
  methods: VerificationLoginMethod[];
  value: VerificationLoginMethod | null;
  onChange: (method: VerificationLoginMethod) => void;
  className?: string;
}

export const TwoFactorMethodPicker: React.FC<TwoFactorMethodPickerProps> = ({
  methods,
  value,
  onChange,
  className = "",
}) => {
  if (methods.length <= 1) return null;

  const countClass =
    methods.length >= 3
      ? "two-factor-method-picker--count-3"
      : "two-factor-method-picker--count-2";

  return (
    <div
      className={`two-factor-method-picker ${countClass} ${className}`.trim()}
      role="tablist"
      aria-label={intl.get("auth.verificationMethod")}
    >
      {methods.map((method) => {
        const meta = METHOD_META[method];
        if (!meta) return null;
        const { labelKey, Icon } = meta;
        const label = intl.get(labelKey);
        const isSelected = value === method;

        return (
          <button
            key={method}
            type="button"
            role="tab"
            aria-selected={isSelected}
            className={`two-factor-method-picker__card${
              isSelected ? " two-factor-method-picker__card--selected" : ""
            }`}
            onClick={() => onChange(method)}
          >
            <Icon className="two-factor-method-picker__icon" aria-hidden />
            <span className="two-factor-method-picker__label">{label}</span>
          </button>
        );
      })}
    </div>
  );
};
